import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Chip } from "@mui/material";
import { capitalizeEachFirstLetterFormatter } from "../../../../utils/formatters";

const OrderFilterChip = ({ label, value, currentFilter, isDescSort, toggleHandler }) => {
    return (
        <Chip
            label={capitalizeEachFirstLetterFormatter((label))}
            color="primary"
            icon={currentFilter === value ? isDescSort ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon /> : null}
            variant={currentFilter === value ? 'contained' : 'outlined'}
            onClick={() => toggleHandler(value)} />
    );
};

export default OrderFilterChip;